import { RouteComponent } from "react-router";

import { RouteFragment, RouteHelper } from "../Imports";

export class ParametrizedRouteFragment<TParams> extends RouteFragment {
    private _parameters: TParams;

    private _onEnter: ((params: TParams) => void)[];
    constructor(
        route: string,
        parameters: TParams,
        component: RouteComponent,
        parent: RouteFragment,
        indexComponent?: RouteComponent | string
    ) {
        super(component, indexComponent);

        this.route = route;
        this.parent = parent;
        this._parameters = parameters;
        parent.registerChild(this);
    }

    public getOnEnterCallbacks(): ((params: TParams) => void)[] {
        return this._onEnter;
    }

    protected formatUrl(): string {
        const url = RouteHelper.insertRouteParameters(this.getRoute(), this._parameters);
        return url;
    }

    protected onEnter(callback: (params: TParams) => void): void {
        this._onEnter = this._onEnter || [];
        this._onEnter.push(callback);
    }
}
